<template>
  <div class="ios-input-row" :class="{ 'ios-input-row--first': first, 'ios-input-row--last': last }">
    <input
      ref="inputRef"
      type="text"
      class="ios-input"
      :value="modelValue"
      :placeholder="placeholder"
      :maxlength="maxlength"
      @input="handleInput"
      @focus="emit('focus')"
      @blur="emit('blur')"
    />
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';

defineProps({
  modelValue: {
    type: String,
    default: ''
  },
  placeholder: {
    type: String,
    default: ''
  },
  maxlength: {
    type: Number,
    default: undefined
  },
  first: {
    type: Boolean,
    default: false
  },
  last: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits(['update:modelValue', 'focus', 'blur']);
const inputRef = ref<HTMLInputElement | null>(null);

const handleInput = (e: Event) => {
  const target = e.target as HTMLInputElement;
  emit('update:modelValue', target.value);
};

const focus = () => {
  inputRef.value?.focus();
};

defineExpose({ focus });
</script>

<style lang="scss" scoped>
.ios-input-row {
  padding: 12px 16px;
  border-bottom: 1px solid rgba(var(--v-theme-sheetText), 0.1);
  
  &--last {
    border-bottom: none;
  }
}

.ios-input {
  width: 100%;
  background: transparent;
  border: none;
  outline: none;
  font-size: 1rem;
  color: rgb(var(--v-theme-sheetText));
  
  &::placeholder {
    color: rgba(var(--v-theme-sheetText), 0.4);
  }
}
</style>
